// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  keycloak: {
    URL: 'https://leapuat.leadics.com/auth',
    redirectURL: 'http://localhost:4200'
  },
  leapUi: {
    URL: 'https://leapuat.leadics.com/apps/leap/rest/user/'
  },
  repoUI: {
    URL: 'https://leapuat.leadics.com/apps/upload/'
  },
  contentManagement: {
    URL: 'https://leapuat.leadics.com/apps/upload/'
  },
  adminConsole: {
    URL: 'https://leapuat.leadics.com/apps/leap/rest/admin/',
    URLRole: 'https://leapuat.leadics.com/apps/leap/rest/user/'
  },
  usageAnalytics: {
    URL: 'https://leapuat.leadics.com/apps/UsageAnalytics/'
  },
  alertsMessages: {
    URL: 'https://leapuat.leadics.com/apps/notificationEngine/webapi/'
  },
  notificationEngine: {
    URL: 'https://leapuat.leadics.com/apps/notificationEngine/webapi/'
  },
  queryBuilder: {
    URL: 'https://leapuat.leadics.com/apps/leap/rest/user/'
  },
  nlpUi: {
    URL: 'https://leapuat.leadics.com/apps/NlpRest/rest/'
  },
  actionPlanning: {
    URL: 'https://leapuat.leadics.com/apps/ActionPlan/',
    PostURL: 'https://leapuat.leadics.com/apps/ActionPlan/'
  },
  autoInsights: {
    URL: ''
  },
  autoscope: {
    URL: 'https://leapuat.leadics.com/apps/autoscopeDashboard/rest/'
  },
  tkml: {
    URL: 'https://leapuat.leadics.com/apps/upload/'
  },
  drive: {
    URL: 'https://leapuat.leadics.com/apps/drive/rest/'
  }
};
